export default {"src":"/_next/static/media/partner34.5dbc48f6.svg","height":75,"width":159,"blurWidth":0,"blurHeight":0};